import SearchEmpty from '@images/search_empty.svg'
import { Message } from '@ui-kit'
import { useTranslation } from 'react-i18next'

export const EmptyMessage = () => {
  const { t } = useTranslation()

  return (
    <Message
      i18n={{
        title: t('message.empty.search.results'),
        message: t('message.empty.search.results.small.2')
      }}
      image={SearchEmpty}
      sizes={{
        titleLevel: 3,
        messageSize: 16,
        imageHeight: 120,
        spaceSize: 10
      }}
    />
  )
}

EmptyMessage.displayName = 'CheckoutPaymentBillingEmptyMessage'
